// extracted by mini-css-extract-plugin
module.exports = {"dialog_insurance":"dialog_insurance-I2bA5","popupHeader":"popupHeader-3WCvh","wrapper_insurance":"wrapper_insurance-sb2mU"};